module.exports = __webpack_public_path__ + "/dist/assets/fonts/fa-light-300.woff";